import { EnvironmentProviders, Provider } from '@angular/core';
import { FpLoggerNoiseHistogramStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-histogram/services/fp-logger-noise-histogram/fp-logger-noise-histogram.store';
import { FpLoggerNoiseHistogramChartService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-histogram/services/fp-logger-noise-histogram-chart.service';
import { FpLoggerNoiseHistogramExportService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-histogram/services/fp-logger-noise-histogram-export.service';
import { FpLoggerNoiseHistogramConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-histogram/services/fp-logger-noise-histogram-connect.service';
import { FP_LOGGER_NOISE_TAB_CONNECT_SERVICES } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/providers/fp-logger-noise-tab-connect-services.token';

export function fpLoggerNoiseHistogramProvider(): (EnvironmentProviders | Provider)[] {
  return [
    FpLoggerNoiseHistogramStore,
    FpLoggerNoiseHistogramChartService,
    FpLoggerNoiseHistogramExportService,
    FpLoggerNoiseHistogramConnectService,
    {
      provide: FP_LOGGER_NOISE_TAB_CONNECT_SERVICES,
      useExisting: FpLoggerNoiseHistogramConnectService,
      multi: true,
    },
  ];
}
